<template>
  <table class="view-dashboard-btn-content" data-interview-dashboard-button="true" role="presentation" width="600" cellspacing="0" cellpadding="0" border="0" bgcolor="#efefef" style="width: 600px; border-collapse: collapse; border-spacing: 0; background-color: #efefef;">
    <tbody>
      <tr>
        <td align="right" style="padding: 0 42px 24px 24px;">
          <table role="presentation" align="right" width="140" cellspacing="0" cellpadding="0" border="0" style="width: 140px; border-collapse: separate; border-spacing: 0; table-layout: fixed; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            <tbody>
              <tr>
                <td data-email-theme-color="true" align="center" :style="themeColorStyle">
                  <a data-email-theme-color="true" :href="dashboardLink" :style="themeLinkStyle">{{ isEnglish ? 'View Dashboard' : '查看总览' }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  props: {
    dashboardLink: {
      type: String,
      required: true
    },
    languageCode: {
      type: String,
      required: true
    },
    themeColor: {
      type: String,
      required: true
    }
  },
  computed: {
    isEnglish () {
      return this.languageCode === 'en'
    },
    themeColorStyle () {
      return `border: 1px solid ${this.themeColor}; color: ${this.themeColor}; padding: 6px 8px; font-size: 14px; line-height: 18px; font-weight: 700; mso-line-height-rule: exactly; white-space: nowrap;`
    },
    themeLinkStyle () {
      return `display: block; color: ${this.themeColor}; font-family: Inter, Arial, sans-serif; font-size: 14px; line-height: 18px; font-weight: 700; mso-line-height-rule: exactly; text-decoration: none; white-space: nowrap;`
    }
  }
}
</script>
